<template>

  <div class="padded">

<!--
    <data-table
      table-ref="revenue-statement-table"
      title="Revenue History"
      :url="'/revenue/site/' + this.siteId"
      :show-search="false"
      sort-field="date"
      :fields="fields">

      <template #admin-action="props">
          <el-button v-if="isSuper()"
            class="hidden-md-and-down"
            type="danger" size="mini" icon="fa fa-trash-alt"
            @click="deletePayment(props.rowData)" circle>
          </el-button>
      </template>

    </data-table>
-->
    <el-row v-if="renewals.length > 0">
      <el-col :span="24">
        <h3>Revenue Renewals</h3>
        <el-table
           :data="renewals"
           stripe
           height="300"
           style="width: 100%">

           <el-table-column
             prop="started"
             label="Started">
             <template #default="scope">
                <date-input v-model="scope.row.started" size="mini" :disabled="!(!scope.row.saved && !scope.row.started)" no-form />
            </template>
           </el-table-column>

           <el-table-column
             prop="expiry"
             label="Expiry">
             <template #default="scope">
                <date-input v-model="scope.row.expiry" size="mini" :disabled="!(!scope.row.saved && !scope.row.expiry)" no-form />
            </template>
           </el-table-column>
           <el-table-column
             prop="amount"
             label="Amount">
             <template #default="scope">
                <float-input v-model="scope.row.amount" size="mini" :disabled="!(!scope.row.saved && !scope.row.amount)" no-form />
            </template>
           </el-table-column>

           <el-table-column
              v-if="showTax()"
             prop="tax"
             :formatter="formatAmount"
             label="Tax" />

             <el-table-column
                v-if="showTax()"
               prop="total"
               :formatter="formatAmount"
               label="Total" />

           <el-table-column align="right">
             <template #default="scope">
               <el-button
                 v-if="isManager() && !scope.row.saved"
                 type="success"
                 size="small"
                 icon="fa fa-check"
                 @click="saveRow(scope.row)">
                 Save
               </el-button>
             </template>
           </el-table-column>

           <el-table-column align="right">
             <template #default="scope">

               <el-button v-if="isSuper()"
                 class="hidden-md-and-down"
                 type="danger" size="mini" icon="fa fa-trash-alt"
                 @click="deletePayment(props.rowData)" circle>
               </el-button>

             </template>
           </el-table-column>
         </el-table>
       </el-col>

      </el-row>
      <el-row v-else>
        <el-col :span="24" align="center">
          <i>No revenue renewal history found</i>
        </el-col>
      </el-row>

  </div>

</template>


<script>

import Vue from 'vue'


import PostMixins from '@/mixins/PostMixins'
import DateMixins from '@/mixins/DateMixins'
import NumberMixins from '@/mixins/NumberMixins'

import {settings} from '@/components/Data'

export default {

  mixins: [PostMixins, DateMixins, NumberMixins],

  props: {

    renewals: {
      type: Array,
      required: true
    }

  },



  methods: {

    deleted () {
      this.$events.emit('revenue-statement-table-refresh-table')
    },

    deletePayment (row) {
      if (row) {
        this.deleteItem(this, row.id, '/revenue', 'Revenue from ' + this.formatDate(row.started) + ' to ' + this.formatDate(row.expiry) + ' for ' + this.currency + row.total, this.deleted)
      }
    },

    formatTerm (row, col, value, index) {
      return this.addSuffix(value, false)
    },


    formatColDate (row, col, value, index) {
      return this.formatDate(value)
    },


    formatAmount (row, col, value, index) {
      return this.formatMoney(value)
    },

    saveRow (renewal) {

      if (renewal && renewal.id) {

        this.saveForm(this, '/revenue', renewal.id, renewal, 'Revenue Renewal', this.savedRowSuccess)

      } else {

        this.$message({message: 'Invalid renewal data, can\'t save.', type: 'warning'})

      }
    },

    savedRowSuccess (data) {

      if (!data || data.id == null) {
        console.warn('savedRowSuccess called without a valid row id', data)
        return
      }

      const idx = this.renewals.findIndex(r => r.id === data.id)

      if (idx < 0) {
        console.warn('savedRowSuccess: no matching row found for id', data.id)
        return
      }

      Vue.set(this.renewals, idx, { ...this.renewals[idx], ...data, saved: true })
    }

  },

  data () {
    return {
      currency: settings.currency,
      localSite: this.rowData,
      taxLabel: settings.taxName,
      fields: [
        {
          name: 'started',
          title: 'Started',
          callback: this.formatDate
        },
        {
          name: 'expiry',
          title: 'Expiry',
          callback: this.formatDate
        },
/*
        {
          name: 'term',
          title: 'Term',
          callback: this.addSuffix,
          titleClass: 'hidden-md-and-down',
          dataClass: 'hidden-md-and-down'
        },
*/
        {
          name: 'amount',
          title: 'Amount',
          callback: this.formatNumber,
          titleClass: 'hidden-sm-and-down',
          dataClass: 'hidden-sm-and-down'
        },
        {
          name: 'tax',
          title: this.taxLabel,
          callback: this.formatNumber,
          visible: this.showTax(),
          titleClass: 'hidden-sm-and-down',
          dataClass: 'hidden-sm-and-down'
        },
        {
          name: 'total',
          title: 'TOTAL',
          callback: this.formatNumber,
          visible: this.showTax()
        },
        {
          name: '__slot:admin-action',
          visible: this.isSuper()
        }
      ]
    }
  }
}

</script>
